module.exports = __webpack_public_path__ + "img/feynman.52081615.svg";